import { Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';

/**
 * Canonicalize paths to no trailing slash (except `/`).
 * Keeps route matches, tab active state, and prefix checks (`/account/…`) consistent
 * without per-callsite path normalization.
 *
 * TODO: Firebase Hosting trailing-slash redirect is configured in `firebase.json`.
 * Remove this component once the 301 redirect has been verified in production; it is
 * still needed for the Vite dev server, which does not apply Firebase Hosting rules.
 */
export function CanonicalPath({ children }: { children: ReactNode }) {
  const location = useLocation();

  if (location.pathname.length > 1 && location.pathname.endsWith('/')) {
    let pathname = location.pathname;
    while (pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1);
    }
    return (
      <Navigate
        replace
        to={{
          pathname,
          search: location.search,
          hash: location.hash,
        }}
        state={location.state}
      />
    );
  }

  return children;
}
